import type { Activity } from 'sr-types/lib/search/v1/graphql';
import { activitySearchByPage } from '../common/utils/incrementalSearchPages';
import { ACTIVITY_CHUNK_SIZE, SCHEDULER_SEARCH_BATCH_SIZE } from './schedulerConstants';

export const fetchProductionActivities = async (
    activeOrganizationAccount: string,
    productionId: string,
    signal?: AbortSignal
): Promise<Activity[]> => {
    const activitySearches = activitySearchByPage(
        activeOrganizationAccount,
        SCHEDULER_SEARCH_BATCH_SIZE,
        [{ filters: [{ identifier: 'production', value: productionId }] }],
        () => undefined,
        undefined,
        ACTIVITY_CHUNK_SIZE,
        true,
        undefined,
        signal,
        undefined,
        true
    );

    const productionActivities = (await Promise.all(activitySearches)).flat();
    return productionActivities;
};
